<div class="menu">
  <nav class="pt-md-5 d-flex flex-column">
    @for (sideBarItem of items; track sideBarItem) {
      <a
        class="btn btn-side-navigation mb-2"
        [routerLink]="sideBarItem.routerLink"
        [routerLinkActive]="['active']">
        <div class="d-flex align-items-center gap-2">
          @if (sideBarItem?.icon) {
            <i-tabler [name]="sideBarItem.icon" class="icon"></i-tabler>
          }
          <span class="label d-inline d-lg-inline">{{
            sideBarItem.label
          }}</span>
        </div>
      </a>
    }
  </nav>

  <div class="footer justify-content-end">
    <a
      class="btn btn-side-navigation mb-2"
      [routerLink]="'/account'"
      [routerLinkActive]="['active']">
      <div class="d-flex align-items-center gap-2">
        <i-tabler name="settings" class="icon"></i-tabler>
        <span class="label d-inline d-lg-inline">{{
          'NAVIGATION.ACCOUNT' | translate
        }}</span>
      </div>
    </a>
    <button
      type="button"
      class="btn btn-side-navigation mb-2"
      (click)="authFacadeService.logout()">
      <div class="d-flex align-items-center gap-2">
        <i-tabler name="logout" class="icon"></i-tabler>
        <span class="label d-inline d-lg-inline">{{
          'NAVIGATION.LOG_OUT' | translate
        }}</span>
      </div>
    </button>
  </div>
</div>
